import { NextSeo, type NextSeoProps } from 'next-seo';
import { useContext } from 'react';
import StaticContext from '~/context/sem/StaticContext';

type OwnProps = Partial<NextSeoProps>;

export default function HeadTags(props: OwnProps) {
  const { pageContent } = useContext(StaticContext);

  const title = pageContent.metaTitle || 'Used Cars for Sale Online | Carvana';

  return (
    <NextSeo
      title={title}
      openGraph={{
        type: 'website',
        siteName: 'Carvana',
        title,
        description: pageContent.metaDescription ?? '',
        images: pageContent.metaImage
          ? [{ url: pageContent.metaImage }]
          : undefined
      }}
      {...props}
    />
  );
}
